import { Host, h } from "@stencil/core";
import QrCreator from "qr-creator";
export class ChQr {
    constructor() {
        this.text = undefined;
        this.radius = 0;
        this.ecLevel = "H";
        this.fill = "black";
        this.background = null;
        this.size = 128;
    }
    qrContainer;
    componentDidLoad() {
        if (this.text) {
            QrCreator.render({
                text: this.text,
                radius: this.radius,
                ecLevel: this.ecLevel,
                fill: this.fill,
                background: this.background,
                size: this.size // in pixels
            }, this.qrContainer);
        }
    }
    render() {
        return (h(Host, null, h("div", { class: "qr-container", ref: el => (this.qrContainer = el) })));
    }
    static get is() { return "ch-qr"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-qr.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-qr.css"]
        };
    }
    static get properties() {
        return {
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | undefined",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Any kind of text, also links, email addresses, any thing."
                },
                "attribute": "text",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "radius": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines how round the blocks should be. Numbers from 0 (squares) to 0.5 (maximum round) are supported."
                },
                "attribute": "radius",
                "reflect": false,
                "defaultValue": "0"
            },
            "ecLevel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ecLevel",
                    "resolved": "\"H\" | \"L\" | \"M\" | \"Q\"",
                    "references": {
                        "ecLevel": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/qr/ch-qr.tsx",
                            "id": "src/components/qr/ch-qr.tsx::ecLevel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Means \"Error correction levels\". The four values L, M, Q, and H will use %7, 15%, 25%, and 30% of the QR\ncode for error correction respectively. So on one hand the code will get bigger but chances are also higher\nthat it will be read without errors later on. This value is by default High (H)"
                },
                "attribute": "ec-level",
                "reflect": false,
                "defaultValue": "\"H\""
            },
            "fill": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "What color you want your QR code to be. By default is black."
                },
                "attribute": "fill",
                "reflect": false,
                "defaultValue": "\"black\""
            },
            "background": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The background color. By default is transparent."
                },
                "attribute": "background",
                "reflect": false,
                "defaultValue": "null"
            },
            "size": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The total size of the final QR code in pixels - it will be a square. This value is by default \"128\""
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "128"
            }
        };
    }
}
//# sourceMappingURL=ch-qr.js.map
